export default __webpack_public_path__ + "static/media/2017 DEC ZURY PASSION-04.99ea4b6f.jpg";